import React, { useEffect } from 'react'

import instacart from 'legacy/common/instacart'

import { type OrderDetailsApiResponse } from 'legacy/routes/orders/details/OrderDetails.types'

export type UseOrderDetailsQueryProps = {
  order_delivery_id: string
  partner_id: string
  warehouse_id: string
}

export const useOrderDetailsQuery = ({
  order_delivery_id,
  partner_id,
  warehouse_id,
}: UseOrderDetailsQueryProps) => {
  const [orderDetails, setOrderDetails] = React.useState<OrderDetailsApiResponse | null>(null)

  useEffect(() => {
    instacart.go
      .get(
        `/v1/partners/${partner_id}/warehouses/${warehouse_id}/order_deliveries/${order_delivery_id}`
      )
      .then((response: OrderDetailsApiResponse) => {
        setOrderDetails(response)
      })
  }, [order_delivery_id, partner_id, warehouse_id])

  return [orderDetails]
}
